/**
 * Highchart Theme: smpl
 * Get More at: http://jkunst.com/highcharts-themes-collection/
 */

module.exports = {
    "colors": ["#d35400", "#2980b9", "#2ecc71", "#f1c40f", "#2c3e50", "#7f8c8d"],
    "chart": {
        "style": {
            "fontFamily": "Noto Sans",
            "color": "#666666"
        }
    },
    "title": {
        "align": "center",
        "style": {
            "fontFamily": "Noto Sans",
            "fontWeight": "normal"
        }
    },
    "subtitle": {
        "align": "left",
        "style": {
            "fontFamily": "Noto Sans"
        }
    },
    "legend": {
        "align": "right",
        "verticalAlign": "bottom"
    },
    "xAxis": {
        "gridLineWidth": 1,
        "gridLineColor": "#F3F3F3",
        "lineColor": "#F3F3F3",
        "minorGridLineColor": "#F3F3F3",
        "tickColor": "#F3F3F3",
        "tickWidth": 1
    },
    "yAxis": {
        "gridLineColor": "#F3F3F3",
        "lineColor": "#F3F3F3",
        "minorGridLineColor": "#F3F3F3",
        "tickColor": "#F3F3F3",
        "tickWidth": 1
    },
    "plotOptions": {
        "line": {
            "marker": {
                "enabled": false
            }
        },
        "spline": {
            "marker": {
                "enabled": false
            }
        },
        "area": {
            "marker": {
                "enabled": false
            }
        },
        "areaspline": {
            "marker": {
                "enabled": false
            }
        },
        "arearange": {
            "marker": {
                "enabled": false
            }
        },
        "bubble": {
            "maxSize": "10%"
        }
    }
}